'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _MyPlaylistsSelectPopup = require('components/MyPlaylistsSelectPopup/MyPlaylistsSelectPopup');

var _MyPlaylistsSelectPopup2 = _interopRequireDefault(_MyPlaylistsSelectPopup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _utils = require('helpers/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylistsAddIcon.scss');

var MyPlaylistsAddIcon = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, myPlaylistsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MyPlaylistsAddIcon, _Component);

  function MyPlaylistsAddIcon() {
    var _ref;

    (0, _classCallCheck3.default)(this, MyPlaylistsAddIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyPlaylistsAddIcon.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistsAddIcon)).call.apply(_ref, [this].concat(args)));

    _this.state = { showPopup: false };
    return _this;
  }

  (0, _createClass3.default)(MyPlaylistsAddIcon, [{
    key: 'onSave',
    value: function onSave() {
      var guids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _props = this.props,
          track = _props.track,
          addMyPlaylistTracks = _props.addMyPlaylistTracks;

      if (guids.length) {
        return addMyPlaylistTracks({ guids: guids, tracksId: [track.id] }).promise;
      }
      return null;
    }
  }, {
    key: 'getDefaultIcon',
    value: function getDefaultIcon() {
      var _props2 = this.props,
          t = _props2.t,
          iconClass = _props2.iconClass;

      return _react2.default.createElement('i', {
        title: t('Add to playlist'),
        className: (0, _classnames2.default)(styles.icon, iconClass),
        onClick: this.showPopup
      });
    }
  }, {
    key: 'showPopup',
    value: function showPopup(e) {
      (0, _utils.stopEvent)(e);
      this.setState({ showPopup: true });
    }
  }, {
    key: 'hidePopup',
    value: function hidePopup() {
      this.setState({ showPopup: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var icon = this.props.icon;
      var showPopup = this.state.showPopup;

      var iconEl = icon || this.getDefaultIcon();

      return _react2.default.createElement(
        'span',
        null,
        iconEl,
        _react2.default.createElement(_MyPlaylistsSelectPopup2.default, {
          show: showPopup,
          onHide: this.hidePopup,
          onSave: this.onSave
        })
      );
    }
  }]);
  return MyPlaylistsAddIcon;
}(_react.Component), _class3.propTypes = {
  addMyPlaylistTracks: _propTypes2.default.func,
  icon: _propTypes2.default.node,
  iconClass: _propTypes2.default.string,
  t: _propTypes2.default.func,
  track: _propTypes2.default.object
}, _class3.defaultProps = {
  track: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSave', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showPopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hidePopup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hidePopup'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = MyPlaylistsAddIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyPlaylistsAddIcon/MyPlaylistsAddIcon.js
// module id = 828
// module chunks = 1